import script from "./LessonLibraryFilterSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonLibraryFilterSidebar.vue?vue&type=script&setup=true&lang=js"

import "./LessonLibraryFilterSidebar.vue?vue&type=style&index=0&id=a01e2ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a01e2ffc"]])

export default __exports__